import axios from "axios";

const ENDPOINT_KEY = "order-form";
const ENDPOINT_URI = "/order-form";

export default function useOrderFormService() {
  return {
    queryKey: ENDPOINT_KEY,
    getAllOrderForms: async () => {
      const response = await axios.get(`${ENDPOINT_URI}`);
      return response.data.payload;
    },
    getOrderFormById: async (id) => {
      const response = await axios.get(`${ENDPOINT_URI}/${id}`);
      return response.data.payload;
    },
    createOrderForm: async ({payload}) => {
      const response = await axios.post(`${ENDPOINT_URI}`, payload);
      return response.data.payload;
    },
    createArchivedOrderForm: async ({payload}) => {
      const response = await axios.post(`${ENDPOINT_URI}/old`, payload);
      return response.data.payload;
    },
    updateOrderForm: async ({id, payload}) => {
      const response = await axios.put(`${ENDPOINT_URI}/${id}`, payload);
      return response.data.payload;
    },
    deleteOrderForm: async (id) => {
      const response = await axios.delete(`${ENDPOINT_URI}/${id}`);
      return response.data.payload;
    },
    getNewOrderFormNumber: async () => {
      const response = await axios.get(`${ENDPOINT_URI}/form-number/new`);
      return response.data.payload;
    },
  };
}
